import {Trans} from '@lingui/macro';
import {isEmpty} from 'lodash';
import React, {FC} from 'react';

import {Handler} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {Button} from '../../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {SettingsFooter} from '../../common/settingsWrapper';
import {EditorErrorsEnum} from '../../editors/commons/editorErrors';
import {RuleEditorErrorList} from './ruleEditorErrorList';
import {EditorStateErrorMap} from './state/ruleEditorState';

/*
 * Types.
 */

interface RuleEditorFooterProps {
  isEditing: boolean;
  // TODO: errors will be merged in follow up PR
  editorErrors: readonly EditorErrorsEnum[];
  stateErrors?: EditorStateErrorMap;

  onCreate: Handler;
  onEdit: Handler;
  onCancel: Handler;
}

/*
 * Component.
 */

export const RuleEditorFooter: FC<RuleEditorFooterProps> = ({
  isEditing,
  onCreate,
  onEdit,
  onCancel,
  editorErrors,
  stateErrors,
}) => {
  const maybeTooltip = maybeRenderTooltip(editorErrors, stateErrors);

  return (
    <SettingsFooter>
      <Button variant={ButtonVariantsEnum.SECONDARY} isRounded onClick={onCancel}>
        <Trans id="rule-editor-footer-cancel">Cancel</Trans>
      </Button>
      <Button
        variant={ButtonVariantsEnum.PRIMARY}
        onClick={isEditing ? onEdit : onCreate}
        isDisabled={Boolean(maybeTooltip)}
        shouldDisallowCursorIfDisabled
        renderTooltip={maybeTooltip}
      >
        {isEditing ? (
          <Trans id="rule-editor-footer-save-changes">Save changes</Trans>
        ) : (
          <Trans id="rule-editor-footer-create-rule">Create rule</Trans>
        )}
      </Button>
    </SettingsFooter>
  );
};

/*
 * Helpers.
 */

function maybeRenderTooltip(editorErrors: readonly EditorErrorsEnum[], stateErrors?: EditorStateErrorMap) {
  return editorErrors.length > 0 || !isEmpty(stateErrors)
    ? () => <RuleEditorErrorList stateErrors={stateErrors} editorErrors={editorErrors} />
    : undefined;
}
